import { BRAND, CURRENCY, HOMEORDER, INTERNETSUBSCRIPTION, MOBILEORDER, MOBILESUBSCRIPTION } from '../../Analytics/AnalyticsConstants';

export interface itemInfoEvent {
  item_id: string;
  item_name: string;
  affiliation: string | number;
  coupon: string | number;
  discount: number;
  index: number;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_category4: string;
  item_category5: string;
  item_list_id: string;
  item_list_name: string;
  item_variant: string;
  location_id: string | number;
  price: number;
  quantity: number;
  promotion_id: string;
  item_available?: string;
}

export interface ecomViewCartInfo {
  item_list_id: string;
  item_list_name: string;
  items: itemInfoEvent;
}

export interface ecomAddCartInfo {
  currency: string;
  value: string | number;
  items: itemInfoEvent[];
}

let itemArray: itemInfoEvent[] = [];
let availableArray: itemInfoEvent[] = [];
let addToCart: itemInfoEvent[] = [];

export const getItemCategory = (item:any)=>{
const prodCategoryObject = { prodCategory: '', prodsubCategory: '', prodsubscription:'' };
if(item?.productType === 'MOBILE'){
  prodCategoryObject.prodCategory = 'Mobile'
  prodCategoryObject.prodsubCategory = 'Postpaid'
  prodCategoryObject.prodsubscription = 'Subscription only'
} else if(item?.productType ==='MOBILEPREPAID_RATEPLAN'){
  prodCategoryObject.prodCategory = 'Mobile'
  prodCategoryObject.prodsubCategory = 'Prepaid'
  prodCategoryObject.prodsubscription = 'No subscription'
} else{
  prodCategoryObject.prodCategory = 'Home'
  switch(item?.productType){
    case 'INTERNET':
      prodCategoryObject.prodsubCategory =  'Internet';
      break;
    case 'TV':
      prodCategoryObject.prodsubCategory =  'TV';
      break;
    case 'VOICE':
      prodCategoryObject.prodsubCategory = 'Phone';
      break;
    default:
      prodCategoryObject.prodsubCategory = '' 
  }
  prodCategoryObject.prodsubscription = 'Subscription only'
}
return prodCategoryObject
}

export const getItemData = (
  item: any,
  data?: any,
  isAvailable?: any
): itemInfoEvent => {
  const { itemCategory, location } = data;
  const discount = item?.prices?.[0]?.priceAlteration?.[0]?.value ?? 0;
  const basePrice = item?.prices?.[0]?.value ?? 0;
  const itemData: itemInfoEvent = {
    item_id: item?.id ?? '',
    item_name: item?.id ?? '',
    affiliation: item?.promotionInfo?.[0]?.campaignId ?? '',
    coupon: '',
    discount: discount && Number(discount),
    index: 0,
    item_brand: BRAND,
    item_category: getItemCategory(item)?.prodCategory,
    item_category2: getItemCategory(item)?.prodsubCategory,
    item_category3: '',
    item_category4: getItemCategory(item)?.prodsubscription,
    item_category5: '',
    item_list_id: itemCategory ? 'Fixnet' : 'Mobile',
    item_list_name: itemCategory ? 'Fixnet' : 'Mobile',
    item_variant: itemCategory?.title ?? itemCategory?.productName ?? itemCategory?.id ?? item?.id,
    location_id: location,
    price: basePrice && Number(basePrice),
    quantity: 1,
    promotion_id: item?.promotionInfo?.[0]?.campaignId ?? ''
  };
  if (isAvailable) {
    itemData.item_available = isAvailable;
  }

  return itemData;
};

export const getEcomInfo = (items: any, category?: any, location?: any, eligibleBundle?: any) => {
  const itemData: any = [];
  let isAvailable = '';
  items?.map((item: any) => {
    if (item?.bundledOffers) {
      item?.bundledOffers?.map((cart: any) => {
        const itemCategory = category == '' ? item : category;
        if (eligibleBundle) {
          isAvailable = eligibleBundle?.includes(item?.id) ? 'yes' : 'no';
        }
        const prodData = getItemData(cart, { itemCategory, location }, isAvailable);
        prodData.item_category3 = `${item?.bundledOffers?.length}P Subscription`
        itemData.push(prodData);
      });
    } else if (item?.productType === 'INTERNET' && !item?.bundledOffers) {
      const itemCategory = { id: item?.id };
      if (eligibleBundle) {
        isAvailable = eligibleBundle?.includes(item?.id) ? 'yes' : 'no';
      }
      const prodData = getItemData(item, { itemCategory, location }, isAvailable);
      prodData.item_category3 = '1P Subscription'
      itemData.push(prodData);
    } else {
      const prodData = getItemData(item, { location });
      if(item?.productType === 'MOBILEPREPAID_RATEPLAN'){
        prodData.item_category3 = ''
      }else{
        prodData.item_category3 = '1P Subscription'
      }
      itemData.push(prodData);
    }
  });
  return itemData;
};

export const getViewCartInfo = (items: any, category: any, location: any): ecomViewCartInfo => {
  let itemListId: any;
  items?.map((item: any) => {
    if (item?.bundledOffers) {
      itemListId = 'Fixnet';
    } else if (item?.productType === 'INTERNET' && !item?.bundledOffers) {
      itemListId = 'Internet';
    } else {
      itemListId = 'Mobile';
    }
  });
  const ecomData: ecomViewCartInfo = {
    item_list_id: itemListId,
    item_list_name: itemListId,
    items: getEcomInfo(items, category, location)
  };
  return ecomData;
};

export const getEcomCartInfo = (
  items: any,
  category: any,
  location: any,
  eligibleBundle?: any
): any => {
  const discontedPrice = items?.[0]?.derivedPrice?.[0]?.value;
  const ecomViewData: ecomAddCartInfo = {
    currency: CURRENCY,
    value: (discontedPrice && Number(discontedPrice)) ?? 0,
    items: getEcomInfo(items, category, location, eligibleBundle)
  };
  return ecomViewData;
};
export const trackEligibleItem = (
  type: string,
  prodData?: any,
  category?: any,
  location?: any,
  eligibleBundle?: any,
  pegaIntegration?: boolean
): void => {
  if (type === 'view') {
    window?.dataLayer.push({
      event: 'view_item_list',
      event_name: 'view_item_list',
      ecommerce: getViewCartInfo(prodData, category, location),
      isPegaEnabled: !!pegaIntegration
    });
  } else if (type === 'addtocart') {
    window?.dataLayer.push({
      event: 'add_to_cart',
      event_name: 'add_to_cart',
      ecommerce: getEcomCartInfo(prodData, category, location),
      transaction_type: prodData?.[0]?.productType === 'MOBILE' ? 'MOBILE_ORDER' : 'HOME_ORDER',
      isPegaEnabled: !!pegaIntegration,
      fromPopup: !!prodData?.[0]?.fromPopup
    });
  } else if (type === 'available') {
    window.dataLayer.push({
      event: 'view_item',
      event_name: 'view_item',
      ecommerce: getEcomCartInfo(prodData, category, location, eligibleBundle),
      isPegaEnabled: !!pegaIntegration
    });
  }
};

export const getItemInfo = (products: any, showPrice: any, isEligible?: any): itemInfoEvent => {
  const productBody = products?.content?.body[0];
  let available;
  if (isEligible === 'yes' || isEligible === 'no') {
    available = true;
  } else {
    available = false;
  }
  const itemData = getItemData(productBody, showPrice);
  if (available === true) {
    itemData.item_available = isEligible;
  }
  return itemData;
};

export const getBundleItemInfo = (products: any, showPrice: any, isEligible?: any): any => {
  const productBody = products?.content?.body[0];
  let available: any;
  if (isEligible === 'yes' || isEligible === 'no') {
    available = true;
  } else {
    available = false;
  }
  products?.productList?.map((item: any) => {
    const itemData = getItemData(products, showPrice);
    if (item?.cProd?.code?.includes('Internet')) {
      itemData.promotion_id = products?.homepromotionObj?.description;
    } else if (item?.cProd?.code?.includes('Mobile')) {
      itemData.promotion_id = products?.mobpromotionObj?.description;
    } else {
      itemData.promotion_id = '';
    }
    itemData.item_id = item?.cProd?.code;
    itemData.item_name = item?.cProd?.code;
    itemData.item_category = products?.displayName;
    itemData.item_category = productBody?.displayName;
    const itemInfo = { ...itemData };
    if (available === true) {
      itemInfo.item_available = isEligible;
    }
    if (isEligible === 'yes' || isEligible === 'no') {
      availableArray.push(itemInfo);
    } else if (isEligible === 'addtocart') {
      addToCart.push(itemData);
    } else {
      itemArray.push(itemData);
    }
  });
};

export const getItemEventValueArray = (products: any, showPrice: any, isEligible?: any) => {
  const productBody = products?.productList;
  if (productBody) {
    if (isEligible === 'yes' || isEligible === 'no' || isEligible === 'addtocart') {
      getBundleItemInfo(products, showPrice, isEligible);
    } else {
      getBundleItemInfo(products, showPrice);
    }
  } else {
    if (isEligible === 'yes' || isEligible === 'no') {
      availableArray.push(getItemInfo(products, showPrice, isEligible));
      itemArray.push(getItemInfo(products, showPrice));
    } else {
      itemArray.push(getItemInfo(products, showPrice));
      addToCart = [getItemInfo(products, showPrice)];
    }
  }
};
